import _isEmpty from 'lodash/isEmpty';

import { FileCategory } from '@/types/fileCategory';
import FileInfo from '@/types/fileInfo';
import { FileInfoType } from '@/types/fileInfoType';

import getProductType from './getProductType';
import { getBrowserApiEndpoint } from './apiEndpoint';

type Params = {
  /** file_info 데이터 */
  file_info?: FileInfoType;
  /* 해당 데이터의 idx (예 - 게시물idx 등)*/
  idx?: string | number;
  /* 파일 카테고리 */
  fileCategory: FileCategory;
  noImgUrl?: string;
  isFile?: boolean;
};

// TODO: 해당 함수 전면 수정
// 1. no-image 전달 안되게 함수 변경
// 2. 데이터 없을시 undefined 전달 혹은 빈 배열 전달
// 3. isFile인자 필요성 체크 후 삭제
export default function getFileInfos({
  file_info,
  idx,
  fileCategory,
  noImgUrl,
  isFile = false,
}: Params) {
  const productType =
    typeof window !== 'undefined'
      ? getProductType(window.location.pathname)
      : '';

  const getNoImg = () => {
    if (noImgUrl) {
      return noImgUrl;
    }

    if (productType === 'admin') {
      return '/images/admin/common/no-img.svg';
    }

    return '/images/apps/common/no-img.svg';
  };

  const NoImgFileInfo = {
    file_html_full_path: getNoImg(),
  } as FileInfo;

  if (!idx) {
    return undefined;
  }
  const fileInfos = file_info?.[fileCategory]?.[idx] as FileInfo[];

  if (_isEmpty(fileInfos)) {
    if (isFile) {
      return [];
    }
    return [NoImgFileInfo];
  }

  return fileInfos.map((file) => {
    return {
      ...file,
      file_html_full_path: `${getBrowserApiEndpoint()}/${file.file_html_full_path.replace(/^\/+/, '')}`,
    };
  });
}
